const experience = [
    {
        title: "Software Engineer",
        company: "Intelligaia",
        date: "April 2021 - August 2022",
        companyLink: "https://intelligaia.com/",
        description: [
            "Developed and deployed full-stack web applications which processed, analyzed, and rendered data visually.",
            "Worked with a team of developers to release a plugin for Figma to export and manage comments in a more intuitive way.",
            "Developed Restful APIs to communicate with the database and the frontend.",
            "Planned, wrote and debugged web applications with complete accuracy.",
        ],
        techStack: [
            "React",
            "Node.js",
            "Express",
            "MongoDB",
            "Mongoose",
            "Jest",
            "MySQL",
            "Koa.js",
            "Firebase",
            "AWS",
        ],
    },
    {
        title: "Web Designer",
        company: "Extech",
        date: "January 2020 - April 2021",
        companyLink: "https://extechdigital.in/",
        description: [
            "Designing prototypes for websites ensuring that they are in line for clients using Figma and Adobe XD",
            "Establishing design guidelines, standards, and best UI/UX practices",
            "Utilized HTML, CSS and JavaScript to develop enterprise-quality code",
        ],
        techStack: [
            "Figma",
            "Adobe XD",
            "HTML5",
            "CSS3",
            "JavaScript",
            "Git",
        ],
    },
];

export { experience };
